import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import rootReducer from "../reducer/index";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

export default store;